var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":function($event){return _vm.submit()}}},[_vm._v("Migrate Billing")])
}
var staticRenderFns = []

export { render, staticRenderFns }